import AuthService from './AuthService';

class ConversationService {
    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_API_URL;
    }

    // Fetch list of conversations. If exportFlag=true, request CSV export via body.
    async getConversation(s3_path, loginAsUri, exportFlag = false, params = {}) {
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_path);
        const url = `${this.apiBaseUrl}/conversations/${encodedPath}` + loginAsUri;
        const options = {
            method: 'POST', // Using POST for both normal and export requests
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const bodyPayload = {};
        if (exportFlag) {
            // Hint server that we expect CSV back
            options.headers['Accept'] = 'text/csv';
            bodyPayload.export_type = 'csv';
            bodyPayload.export = 'csv';
        }
        if (params && (params.start_date || params.end_date)) {
            // Expect params.start_date/end_date as epoch seconds
            if (params.start_date) bodyPayload.start_date = params.start_date;
            if (params.end_date) bodyPayload.end_date = params.end_date;
        }
        if (Object.keys(bodyPayload).length) {
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(bodyPayload);
        }
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // If backend returns CSV we detect via Content-Type and return structured object
        const contentType = (response.headers.get('Content-Type') || '').toLowerCase();
        if (contentType.includes('text/csv')) {
            const disposition = response.headers.get('Content-Disposition') || '';
            const match = disposition.match(/filename="?([^";]+)"?/);
            const filename = match ? match[1] : 'conversations.csv';
            const blob = await response.blob();
            return { blob, filename }; // Caller can initiate download
        }

        // Fallback to JSON for normal flow
        const data = await response.json();
        return data;
    }

    async getConversationDetails(s3_path, transcription_id, loginAsUri) {
        const token = AuthService.getAccessToken();
        const s3_path_encoded = encodeURIComponent(s3_path);
        const url = `${this.apiBaseUrl}/conversations/${s3_path_encoded}/${transcription_id}` + loginAsUri;
        const response = await fetch(url, {
            method: 'POST', // Changed from default GET to POST
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }


}
// Also export the class so consumers can instantiate a fresh service if needed
export { ConversationService };
const conversationService = new ConversationService();
// HMR/legacy instance safety: ensure new methods exist on the default instance
if (typeof conversationService.getConversationDetails !== 'function') {
    // Bind the class method to the existing instance so imports keep working
    conversationService.getConversationDetails = ConversationService.prototype.getConversationDetails.bind(conversationService);
}
export default conversationService;